import { FC } from 'react';
import Image from 'next/image';
import { Chip, IChipProps, numberFormat, Text } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { IRowCardProps, RowCard } from '@/components/RowCard';
import PulseBadge from '../PulseBadge';

interface IScheduleRowCardProps {
  variant: IChipProps['variant'];
  statusTitle: string;
  amount: number;
  schedulesDescription?: string;
  sourceLogo?: string;
  sourceTitle: string;
  destinationLogo?: string;
  destinationTitle: string;
  shouldShowBadge?: boolean;
  onClick?: IRowCardProps['onClick'];
  isClockIconVisible?: boolean;
}

export const ScheduleRowCard: FC<IScheduleRowCardProps> = ({
  variant,
  statusTitle,
  amount,
  schedulesDescription,
  sourceLogo,
  destinationLogo,
  sourceTitle,
  destinationTitle,
  shouldShowBadge,
  onClick,
  isClockIconVisible = true,
}) => {
  const chipComponent = statusTitle ? (
    <Chip size="xxs" variant={variant}>
      {statusTitle}
      {shouldShowBadge && (
        <div className="ml-[-4px] mr-1 flex items-center">
          <div className="h-2 w-2 transform">
            <PulseBadge />
          </div>
        </div>
      )}
    </Chip>
  ) : null;

  return (
    <>
      <RowCard
        classNames={{
          title: '!text-xs !font-demibold !text-gray-filled-primary-enabled',
          description: '!mt-0 !text-xs !text-gray-filled-secondary-enabled',
          root: '!px-0 !py-[18px]',
          content: ' !w-[40%]',
        }}
        description={
          schedulesDescription ? (
            <div className="flex items-center gap-x-1">
              {isClockIconVisible && (
                <div className="w-[12px]">
                  <Icon
                    className="text-gray-filled-secondary-enabled"
                    icon="clock"
                    size={12}
                  />
                </div>
              )}
              <div>{schedulesDescription}</div>
            </div>
          ) : undefined
        }
        imageComponent={
          <div className="flex">
            <div className="flex h-8 w-8 items-center justify-center rounded-[6px] bg-neutral-filled-tertiary-enabled p-[3px]">
              {sourceLogo && (
                <Image
                  alt={sourceTitle}
                  className="rounded-full"
                  height={20}
                  src={sourceLogo}
                  width={20}
                />
              )}
            </div>
            {destinationLogo && (
              <div
                className={
                  '-mr-3 mt-5 flex h-5 w-5 items-center justify-center overflow-hidden rounded-full'
                }
              >
                <Image
                  alt={destinationTitle}
                  height={20}
                  src={destinationLogo}
                  width={20}
                />
              </div>
            )}
          </div>
        }
        secondDescription={chipComponent}
        {...(amount
          ? {
              secondTitle: (
                <Text
                  className="flex items-baseline gap-x-1 text-gray-filled-primary-enabled"
                  size="sm"
                  weight="medium"
                >
                  {numberFormat(amount)}
                  <Text
                    className="!font-regular text-gray-filled-secondary-enabled"
                    size="xs"
                  >
                    ریال
                  </Text>
                </Text>
              ),
            }
          : {})}
        title={
          <div className=" inline-block w-full items-end gap-x-1 overflow-hidden overflow-ellipsis whitespace-nowrap">
            {sourceTitle}{' '}
            <Icon color="gray-black" icon="arrow_left" size={16} />
            {destinationTitle}
          </div>
        }
        onClick={onClick}
      />
    </>
  );
};
